<template>
  <div class="costConfirm main-content">
    <el-card class="p-t-hg">
      <div class="collapse-content">
        <base-form
          v-model="baseData"
          :options="options"
          ref="baseData"
          label-width="100px"
        ></base-form>

        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="table"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :columns="column"
            :edit-rules="rules"
            :toolbar="{}"
            :max-height="$store.state.app.tableHeight"
            :valid-config="{ autoPos: true, message: 'inline' }"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="exportFile()"
                type="primary"
                icon="el-icon-upload"
                class="vxe-btn-primary"
                >{{ $t('costConfirmationList.router.export') }}</vxe-button
              >
              <vxe-button
                @click="insertEvent(-1)"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('functionBtn.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete()"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('functionBtn.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </div>
    </el-card>
    <div class="fixed-bottom-btnList">
      <el-button @click="handleSave" type="primary" :loading="load">{{
        $t('functionBtn.save')
      }}</el-button>
    </div>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  // import DictSelect from '@/components/DictSelect';
  // import inputNumber from '@/components/form-item/input-number';
  export default {
    name: 'costConfirmationDetails',
    components: {
      baseForm,
      // DictSelect,
      // inputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      options() {
        return [
          // {
          //   //成本确认单号
          //   type: "input",
          //   prop: "confirmNo",
          //   label: this.$t("costConfirmationList.column.confirmNo"),
          //   disabled: true,
          //   required: true,
          // },
          {
            //成本确认月份
            type: 'input',
            prop: 'confirmMonth',
            label: this.$t('costConfirmationList.column.confirmMonth'),
            disabled: true,
            required: true,
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            //序号
            type: 'seq',
            width: 80,
            title: this.$t('costConfirmationList.column.sortNo'),
          },
          {
            //商品大类
            field: 'goodsType',
            title: this.$t('costConfirmationList.column.goodsTypeName'),
            footerAlign: 'center',
            editRender: { name: 'ElSelect', props: { clearable: true } },
            width: '140',
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.goodsTypeName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <dict-select
                    placeholder={this.$t('collarDetailsList.column.selectPlaceholder')}
                    type="produce_product_category"
                    value={row['goodsType']}
                    onChange={(val, label) => this.handleChangeInput(val, label, row, 'goodsType')}
                  ></dict-select>,
                ];
              },
            },
          },
          {
            //商品小类
            field: 'productName',
            title: this.$t('costConfirmationList.column.productName'),
            width: '140',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            //供应商
            field: 'partnerName',
            title: this.$t('costConfirmationList.column.partnerCode'),
            width: '140',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            //合同日期
            field: 'contractDate',
            title: this.$t('costConfirmationList.column.contractDate'),
            editRender: {
              name: 'ElDatePicker',
              props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
            },
            width: '140',
          },
          {
            //结算数量
            field: 'settlementCount',
            title: this.$t('costConfirmationList.column.settlementCountUnit'),
            maxlength: '20',
            width: '140',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.settlementCount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementCount']}
                    max={99999999999.99}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementCount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            //含税结算金额
            field: 'settlementAmountWithTax',
            title: this.$t('costConfirmationList.column.settlementAmountWithTaxUnit'),
            maxlength: '20',
            width: '130',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.settlementAmountWithTax}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementAmountWithTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementAmountWithTax')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            //含税结算单价
            field: 'settlementPriceWithTax',
            title: this.$t('costConfirmationList.column.settlementPriceWithTaxUnit'),
            maxlength: '20',
            width: '130',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                /* row["settlementAmountWithoutTax"] = this.$cal.accMul(row["settlementCount"],row["settlementPriceWithoutTax"])+""; */
                return [<span>{row.settlementPriceWithTax}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementPriceWithTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementPriceWithTax')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            //不含税结算金额
            field: 'settlementAmountWithoutTax',
            title: this.$t('costConfirmationList.column.settlementAmountWithoutTaxUnit'),
            maxlength: '20',
            width: '130',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.settlementAmountWithoutTax}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementAmountWithoutTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) =>
                      this.handleChangeNumber(val, row, 'settlementAmountWithoutTax')
                    }
                  ></input-number>,
                ];
              },
            },
          },
          {
            //不含税结算单价
            field: 'settlementPriceWithoutTax',
            title: this.$t('costConfirmationList.column.settlementPriceWithoutTaxUnit'),
            maxlength: '20',
            width: '130',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.settlementPriceWithoutTax}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementPriceWithoutTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) =>
                      this.handleChangeNumber(val, row, 'settlementPriceWithoutTax')
                    }
                  ></input-number>,
                ];
              },
            },
          },
          {
            //操作人
            field: 'createPersonNo',
            title: this.$t('costConfirmationList.column.createPersonNo'),
            visible: true,
            width: 140,
          },
          {
            //业务部门
            field: 'businessDepartmentCode',
            title: this.$t('costConfirmationList.column.businessDepartmentCode'),
            visible: true,
            width: 140,
          },
          {
            //公司
            field: 'businessCompanyCode',
            title: this.$t('costConfirmationList.column.businessCompanyCode'),
            visible: true,
            width: 140,
          },
        ];
      },
      rules() {
        return {
          goodsType: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.goodsType'),
            },
          ],
          settlementCount: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.settlementCount'),
            },
          ],
          settlementPriceWithoutTax: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.settlementPriceWithoutTax'),
            },
          ],
        };
      },
    },
    data() {
      return {
        load: false,
        baseData: {
          confirmNo: null, //成本确认单号
          confirmMonth: null, //成本确认月份
        },
        tableData: [], //列表数据
      };
    },
    methods: {
      handleSave() {},

      // 载具表格新增一行
      insertEvent(row) {
        //this.$confirm("新增","是否在当前的成本确认月中新增一行数据");
        this.$XModal.confirm('是否在当前的成本确认月中新增一行数据?').then((type) => {
          if (type === 'confirm') {
            this.$refs.table.validate().then(() => {
              let record = {};
              this.$refs.table.insertAt(record, row).then(({ row }) => {
                row.createPersonNo = this.userInfo.userName;
                row.businessDepartmentCode = this.userInfo.departmentName;
                row.businessCompanyCode = this.userInfo.companyName;
                this.$refs.table.setActiveRow(row);
              });
            });
          } else if (type === 'cancel') {
            this.$baseRequest.linkRouteUrl(
              '/production/costConfirmationAdd',
              'costConfirmationAdd',
              ''
            );
          }
        });
      },
      handleChangeInput(val, label, row, type) {
        if (type == 'goodsType') {
          row[type] = val;
          row.goodsTypeName = label;
          row.productCode = ' ';
          row.productName = ' ';
          row.goodsType = null;
          setTimeout(() => {
            row.goodsType = val;
          }, 10);
        }
        if (type == 'productCode') {
          row[type] = val.value;
          row.productName = val.label;
        }
        if (type == 'partnerCode') {
          row[type] = val.partnerCode;
          row.partnerName = val.partnerZhName;
        }
      },
      handleChangeNumber(val, row, type) {
        row[type] = val;
      },
      // 删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancelled'),
            });
          });
      },
    },
  };
</script>
